export default __webpack_public_path__ + "static/ecosystemsept-b578c2af68b79db5acc2352035205519.jpg";